
/* START_TEMPLATE */
define('hbs!templates/composite/apiKeys',['hbs','hbs/handlebars','libs/handlebars-helpers/i18n'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers);
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"row\">\n	<div class=\"col-md-4 col-sm-4 col-xs-4 keys-header\">"
    + escapeExpression((helper = helpers.i18n || (depth0 && depth0.i18n),options={hash:{}},helper ? helper.call(depth0, "keys.table.nameHeader", options) : helperMissing.call(depth0, "i18n", "keys.table.nameHeader", options)))
    + "</div>\n	<div class=\"col-md-7 col-sm-7 col-xs-7 keys-header\">"
    + escapeExpression((helper = helpers.i18n || (depth0 && depth0.i18n),options={hash:{}},helper ? helper.call(depth0, "keys.table.credentialsHeader", options) : helperMissing.call(depth0, "i18n", "keys.table.credentialsHeader", options)))
    + "</div>\n	<div class=\"col-md-1 col-sm-1 col-xs-1 keys-header\">"
    + escapeExpression((helper = helpers.i18n || (depth0 && depth0.i18n),options={hash:{}},helper ? helper.call(depth0, "keys.table.statusHeader", options) : helperMissing.call(depth0, "i18n", "keys.table.statusHeader", options)))
    + "</div>\n	<div class=\"col-md-1 col-sm-1 col-xs-1 keys-header\"></div>\n</div>";
  return buffer;
  });
Handlebars.registerPartial('templates/composite/apiKeys', t);
return t;
});
/* END_TEMPLATE */
;
